var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotificationsActiveFill = function SvgNotificationsActiveFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "notifications_active_fill_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#notifications_active_fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M4.376 15.738a.6.6 0 0 1-.445-.18.6.6 0 0 1-.18-.445q0-.266.18-.446t.445-.18h.882V8.27q0-1.68 1.037-2.973A4.6 4.6 0 0 1 8.96 3.645v-.52q0-.433.305-.736.305-.305.737-.305.433 0 .737.305.305.303.305.737v.519a4.6 4.6 0 0 1 2.664 1.652 4.6 4.6 0 0 1 1.038 2.973v6.218h.881q.267 0 .446.18.18.179.18.445t-.18.445a.6.6 0 0 1-.446.18zm5.625 2.34q-.623 0-1.065-.442a1.45 1.45 0 0 1-.441-1.065h3.013q0 .623-.442 1.065T10 18.078M2.806 8.262a.57.57 0 0 1-.446-.203.6.6 0 0 1-.154-.477 7.5 7.5 0 0 1 .835-2.886 7.9 7.9 0 0 1 1.813-2.3.65.65 0 0 1 .47-.168.54.54 0 0 1 .424.233.6.6 0 0 1 .119.472.74.74 0 0 1-.249.44 6.4 6.4 0 0 0-1.45 1.88 6.6 6.6 0 0 0-.69 2.352.8.8 0 0 1-.216.465.6.6 0 0 1-.456.192m14.39 0a.6.6 0 0 1-.455-.192.8.8 0 0 1-.216-.465 6.6 6.6 0 0 0-.691-2.353 6.4 6.4 0 0 0-1.45-1.88.74.74 0 0 1-.248-.439.6.6 0 0 1 .118-.472.54.54 0 0 1 .424-.233.64.64 0 0 1 .47.168 7.9 7.9 0 0 1 1.813 2.3q.7 1.332.835 2.886a.6.6 0 0 1-.154.477.57.57 0 0 1-.445.203"
  }))));
};
export default SvgNotificationsActiveFill;